package br.com.texeratx.boardgametimeapp.data.repository

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.data.model.stats.GameDurationStatsDTO
import br.com.texeratx.boardgametimeapp.data.model.stats.StatsOverviewDTO
import br.com.texeratx.boardgametimeapp.data.model.stats.YearHistoryDTO
import io.ktor.client.call.body

class StatsRepository(
    private val api: ApiClient,
    private val sessionManager: SessionManager
) {

    suspend fun getGlobalStats(): Result<StatsOverviewDTO> {
        return try {
            val session = sessionManager.load()
                ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.get("stats/global")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getYearHistory(year: Int): Result<YearHistoryDTO> {
        return try {
            val session = sessionManager.load()
                ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.get("stats/year/$year")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getDurationStats(): Result<List<GameDurationStatsDTO>> {
        return try {
            val session = sessionManager.load()
                ?: return Result.failure(Exception("Sessão expirada"))

            val response = api.get("stats/duration")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
